import { NavLink } from "react-router";
import { Button, Table } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import use3rdPartyCalculation from "./use3rdPartyCalculation";

export function Lighthouse3rdParty() {
    const [data, calculateData] = use3rdPartyCalculation();

    return (
        <div className="p-8">
            <NavLink to="/" className="absolute top-4 left-4">
                <ArrowBackIcon />
            </NavLink>
            <div className="flex flex-col justify-center items-stretch gap-8 mb-8">
                <h1 className="text-3xl font-bold">Lighthouse 3rd Party Visualization</h1>
                <p className="text-lg">
                    Upload lighthouse result JSON here:
                    {" "}
                    <Button
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                    >
                        Upload files
                        {" "}
                        <input
                            type="file"
                            accept=".json,application/json"
                            hidden
                            onChange={(event) => calculateData(event.target.files?.[0])}
                        />
                    </Button>
                </p>
                <div className="border border-gray-300 rounded p-4">
                    {
                        typeof data === "string"
                            ? data
                            : (
                                <Table>
                                    <thead>
                                        <tr>
                                            <th className="text-left p-2">Third Party</th>
                                            <th className="text-right p-2">Size (KB)</th>
                                            <th className="text-right p-2">Requests</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.thirdParties.map((tp) => (
                                            <tr key={tp.name} className="border-t">
                                                <td className="p-2">{tp.name}</td>
                                                <td className="p-2 text-right">{(tp.size / 1024).toFixed(2)}</td>
                                                <td className="p-2 text-right">{tp.requests}</td>
                                            </tr>
                                        ))}
                                        {data && (
                                            <tr className="border-t font-bold">
                                                <td className="p-2">Total</td>
                                                <td className="p-2 text-right">{(data.thirdPartySize / 1024).toFixed(2)} KB / {(data.totalAppSize / 1024).toFixed(2)} KB</td>
                                                <td className="p-2 text-right">{(data.thirdPartySize / data.totalAppSize * 100).toFixed(2)} %</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            )
                    }
                </div>
            </div>
        </div>
    );
}

export default Lighthouse3rdParty;
